"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _index = require("./featuredSidebar/index.lazy");

var _featuredBanner = _interopRequireDefault(require("./featuredBanner"));

var _zod = require("zod");

var _classnames = _interopRequireDefault(require("classnames"));

var showWidget = function showWidget(widget, data) {
  var widgetComponents = {
    featuredSide: (0, _preact.h)(_index.FeaturedSidebar, {
      data: data
    }),
    featuredBanner: (0, _preact.h)(_featuredBanner.default, {
      data: data
    })
  };
  return widgetComponents[widget];
};

var widgetName = 'announcement_card';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-announcement_card';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.unknown();

exports.config = config;

var FeaturedTopicsWrapper = function FeaturedTopicsWrapper(_ref) {
  var widget = _ref.widget,
      _ref$topics = _ref.topics,
      topics = _ref$topics === void 0 ? [] : _ref$topics;

  if (!topics.length) {
    return null;
  }

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('widget--notification', 'qa-widget-notification', 'custom-notification')
  }, (0, _preact.h)("div", {
    className: widget
  }, showWidget(widget, topics)));
};

var _default = FeaturedTopicsWrapper;
exports.default = _default;